import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields, purchasedMaterialFields } from './common/productFields';
import { msg } from '@lingui/core/macro';
import { fuelKindField } from './common/fuelFields';
import {
  distanceQuantityField,
  distanceUnitField,
  isCompanyOwnedOrLeasedField,
  vehicleCategoryField,
  vehiclePowertrainTypeField,
  vehicleTypeField,
  electricityEfficiencyField,
  fuelEfficiencyField,
} from './common/travelFields';

export const vehiclesMetadata = {
  displayName: msg({
    message: 'Vehicle travel',
    context: 'Activity data schema name for vehicle travel',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    distance_quantity: {
      ...distanceQuantityField,
      externalDescription: msg({
        message:
          'How far a vehicle traveled. Trip distance is multiplied by passenger quantity to get the total distance.',
        context: 'Distance',
      }),
    },
    // NOTE: quantity does not exist on the BAT but distance_quantity is
    // renamed to quantity in the BART-EM matching process
    quantity: distanceQuantityField,
    distance_unit: distanceUnitField,
    electricity_efficiency: electricityEfficiencyField,
    electricity_efficiency_unit: {
      displayName: msg({
        message: 'Electricity efficiency unit',
        context: 'The display name for a dimension',
      }),
    },
    fuel_efficiency: fuelEfficiencyField,
    fuel_efficiency_unit: {
      displayName: msg({
        message: 'Fuel efficiency unit',
        context: 'The display name for a dimension',
      }),
    },
    fuel_kind: fuelKindField,
    fuel_quantity: {
      displayName: msg({
        message: 'Fuel consumption',
        context: 'The display name for a metric',
      }),
    },
    fuel_unit: {
      displayName: msg({
        message: 'Raw fuel unit',
        context: 'The display name for a dimension',
      }),
    },
    is_company_owned_or_leased: isCompanyOwnedOrLeasedField,
    vehicle_category: vehicleCategoryField,
    vehicle_powertrain_type: vehiclePowertrainTypeField,
    vehicle_type: vehicleTypeField,
    vehicle_usage_reason: {
      displayName: msg({
        message: 'Vehicle usage reason',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({ message: 'The reason for vehicle usage.' }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
